import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { canManage } from "../../common/validators";
import { getBackgroundColorStatusNumber } from "../../common/statusIcons";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
// ICONS
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { GreyButtonNoShadow } from "../styled";
import { red } from "@mui/material/colors";

export default function ModalHeader({
  label,
  margin,
  canOnFiscal,
  onFiscal,
  onDelete,
  onAdd,
  dividerText,
  onClose,
  status = null,
}) {
  const userType = useSelector((state) => state.auth.user.user_type);

  return (
    <Box
      sx={{
        mt: margin ?? 0,
        mb: margin ?? 0,
        px: 2,
        pt: 2,
        top: 0,
        zIndex: 9999,
        border: "none",
        position: "sticky",
        background: "#ffffff",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        marginBottom={1}
      >
        <Typography id="modal-title" variant="h6" component="h6">
          {label}
        </Typography>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          {onAdd && (
            <Link to="/restaurant/new" title="Cadastrar" onClick={onClose}>
              <IconButton
                aria-label="add-action-modal"
                title="Adicionar Restaurante"
              >
                <AddBusinessIcon />
              </IconButton>
            </Link>
          )}
          {onFiscal && (
            <GreyButtonNoShadow
              variant="text"
              aria-label="emitir-nota-fiscal"
              title="Nota Fiscal"
              fontWeight="bold"
              startIcon={<ReceiptIcon />}
              disabled={!canOnFiscal}
              onClick={onFiscal}
            >
              Nota Fiscal {!canOnFiscal && "(Sem Configuração)"}
            </GreyButtonNoShadow>
          )}
          {onDelete && canManage(userType) && (
            <GreyButtonNoShadow
              variant="text"
              aria-label="cancelar-pedido"
              title="Cancelar"
              textColor={red["600"]}
              fontWeight="bold"
              startIcon={<DeleteIcon />}
              onClick={onDelete}
            >
              Cancelar
            </GreyButtonNoShadow>
          )}
          {onClose && (
            <IconButton aria-label="close-modal" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          )}
        </Stack>
      </Stack>
      <Divider>
        {dividerText && (
          <Chip
            label={dividerText}
            className={getBackgroundColorStatusNumber(status)}
          />
        )}
      </Divider>
    </Box>
  );
}
